(function () {
  document.documentElement.classList.add("is-ox-ready");

  var wrap = document.querySelector(".page-wrapper");

  function scrollY() {
    var windowY = window.scrollY || document.documentElement.scrollTop || 0;
    var wrapY = wrap ? wrap.scrollTop : 0;
    return Math.max(windowY, wrapY);
  }

  function scrollToTop() {
    var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var behavior = reduced ? "auto" : "smooth";
    if (wrap) wrap.scrollTo({ top: 0, behavior: behavior });
    window.scrollTo({ top: 0, behavior: behavior });
  }

  var header = document.querySelector("[data-ox-header]");
  var drawer = document.querySelector("[data-ox-drawer]");
  var topBtn = document.querySelector("[data-ox-top]");
  var headerH = 0;

  function setHeaderH() {
    if (!header) return;
    var compact = header.classList.contains("is-scrolled") || header.classList.contains("is-hidden");
    if (!compact) headerH = header.offsetHeight;
    if (headerH) document.documentElement.style.setProperty("--ox-header-h", headerH + "px");
  }

  setHeaderH();
  window.addEventListener("resize", setHeaderH);
  var lastY = scrollY();
  var ticking = false;

  function onScroll() {
    var y = scrollY();
    if (header) {
      header.classList.toggle("is-scrolled", y > 40);
      if (y < 80) {
        header.classList.remove("is-hidden");
      } else if (y > lastY + 4) {
        header.classList.add("is-hidden");
      } else if (y < lastY - 4) {
        header.classList.remove("is-hidden");
      }
    }
    if (topBtn) {
      topBtn.classList.toggle("is-visible", y > 400);
    }
    lastY = y;
    ticking = false;
  }

  function requestScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(onScroll);
  }

  window.addEventListener("scroll", requestScroll, { passive: true });
  if (wrap) wrap.addEventListener("scroll", requestScroll, { passive: true });
  onScroll();

  if (topBtn) {
    topBtn.addEventListener("click", function () {
      scrollToTop();
    });
  }

  var openBtn = document.querySelector("[data-ox-menu-open]");
  var closeBtn = document.querySelector("[data-ox-menu-close]");
  if (openBtn && drawer) {
    openBtn.addEventListener("click", function () {
      drawer.hidden = false;
    });
  }
  if (closeBtn && drawer) {
    closeBtn.addEventListener("click", function () {
      drawer.hidden = true;
    });
  }

  var reveals = document.querySelectorAll(".ox-reveal");
  if ("IntersectionObserver" in window) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-in");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, root: wrap && wrap.scrollHeight > wrap.clientHeight ? wrap : null }
    );
    reveals.forEach(function (el) {
      io.observe(el);
    });
  } else {
    reveals.forEach(function (el) {
      el.classList.add("is-in");
    });
  }

  var carousel = document.querySelector("[data-ox-carousel]");
  if (carousel) {
    var slides = Array.prototype.slice.call(carousel.querySelectorAll("[data-ox-slide]"));
    var bar = carousel.querySelector("[data-ox-progress]");
    var prev = carousel.querySelector("[data-ox-prev]");
    var next = carousel.querySelector("[data-ox-next]");
    var duration = parseInt(carousel.getAttribute("data-interval") || "6000", 10);
    var index = 0;
    var timer = null;
    var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    function playVideos(active) {
      slides.forEach(function (slide, i) {
        var video = slide.querySelector("video");
        if (!video) return;
        if (i === active) {
          video.play().catch(function () {});
        } else {
          video.pause();
          try {
            video.currentTime = 0;
          } catch (e) {}
        }
      });
    }

    function restartProgress() {
      if (!bar) return;
      bar.classList.remove("is-running");
      bar.style.animationDuration = "";
      void bar.offsetWidth;
      if (reduced || slides.length < 2) {
        bar.style.width = "100%";
        return;
      }
      bar.style.width = "0";
      bar.style.animationDuration = duration + "ms";
      bar.classList.add("is-running");
    }

    function goTo(nextIndex) {
      if (!slides.length) return;
      slides[index].classList.remove("is-active");
      index = (nextIndex + slides.length) % slides.length;
      slides[index].classList.add("is-active");
      playVideos(index);
      restartProgress();
      restartTimer();
    }

    function restartTimer() {
      if (timer) window.clearInterval(timer);
      if (reduced || slides.length < 2) return;
      timer = window.setInterval(function () {
        goTo(index + 1);
      }, duration);
    }

    if (prev) {
      prev.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        goTo(index - 1);
      });
    }
    if (next) {
      next.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        goTo(index + 1);
      });
    }

    if (slides.length) {
      slides[0].classList.add("is-active");
      playVideos(0);
      restartProgress();
      restartTimer();
    }
  }

  document.querySelectorAll("[data-parallax]").forEach(function (el) {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    var speed = parseFloat(el.getAttribute("data-parallax") || "0.12");
    function tick() {
      var parent = el.parentElement;
      if (!parent) return;
      var rect = parent.getBoundingClientRect();
      var progress = (rect.top + rect.height / 2 - window.innerHeight / 2) / window.innerHeight;
      el.style.transform = "translate3d(0," + progress * speed * -100 + "px,0)";
      requestAnimationFrame(tick);
    }
    tick();
  });
})();
